import { Uuid } from "@/domains/global/identifiers";
import { resolveSyncModelNamespacedUuid } from "@/modules/uuid/sync-models/resolveSyncModelNamespacedUuid";
import { SyncModelKind } from "@/store/sync/types";

export const resolveNoteSourceSyncModelUuid = ({
  noteId,
  sourceId,
}: {
  noteId: Uuid;
  sourceId: Uuid;
}): Uuid => {
  return resolveSyncModelNamespacedUuid({
    modelKind: { value: SyncModelKind.NoteSource },
    uuids: [noteId, sourceId],
  });
};
